import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import ContentArea from '@episerver/spa-core/Components/ContentArea';
import {getRecaptchaToken} from '../../../utilities/recaptcha/recaptcha';
import {GetTransactionSummaryData} from './TransactionSummarySlice';
import FailureScreen from '../../Shared/FailureScreen/FailureScreen';
import Config from '../../../Config';
import Loader from '../../Shared/LocalLoader/LocalLoader';
import DisconnectProductsPage from '../../Block/DisconnectServicesBlock/DisconnectPage/DisconnectCommonParts/DisconnectProductsPage';

const TransactionSummary = ({contentData, context, GetTransactionSummaryData, transactionData, isDataLoaded = false, errorCode}) => {
  useEffect(() => {
    (async () => {
      // send to server
      GetTransactionSummaryData({guidId: GetOrderIdFromUrl()});
    })();
  }, []);

  const transactionSummaryPage = SetTransactionData(contentData.mainContentArea, context, transactionData, isDataLoaded, errorCode);

  return transactionSummaryPage;
};

function SetTransactionData(mainContentArea, context, transactionData, isDataLoaded = false, errorCode = '00') {
  let content = <Loader />;

  if (errorCode === '00') {
    if (isDataLoaded) {
      if (transactionData !== null && Object.keys(transactionData).length > 0 && transactionData.statusMessage.returnCode === '00') {
        content = (
          <div className='transaction-summary-page__container'>
            <ContentArea context={context} data={mainContentArea} propertyName='mainContentArea' />
          </div>
        );
      } else content = <FailureScreen errorId={99} />;
    }
  } else if (errorCode === '19') content = <FailureScreen errorId={99} />;

  return <div className='transaction-summary-page'>{content}</div>;
}
//   <DisconnectProductsPage equipmentList={""}/>
function GetOrderIdFromUrl() {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  return urlParams.get('orderId');
}

const mapStateToProps = (state) => {
  return {
    transactionData: state.cellcomTransactionSummary.transactionData,
    isDataLoaded: state.cellcomTransactionSummary.isSuccess,
    errorCode: state.cellcomTransactionSummary.errorCode,
  };
};
const mapDispatchToProps = {
  GetTransactionSummaryData,
};

export default connect(mapStateToProps, mapDispatchToProps)(TransactionSummary);
